import styled from 'styled-components/native';
import { color, layout, position, system } from 'styled-system';
const ImageBackground = styled.ImageBackground `
  ${color}
  ${layout}
  ${position}
  ${system({
    tintColor: true
})}
`;
export default ImageBackground;
